var campaignApi = require('../../api/campaign')

exports.CampaignComment = App.Views.Base.extend({
  el: '.js-campaign-comment',
  initialize: function() {
    this.$commentList = $('.js-campaign-comment-list', this.$el)
    this.$loading = $('.js-campaign-comment-loading', this.$el)

    this.load()
  },
  $commentList: null,
  $loading: null,
  limit: 100,
  offset: null,
  load: function() {
    var campaignId = this.$el.data('campaignId')
    var _this = this

    this.$loading.show()
    $('.js-campaign-comment-load-more').remove()
    campaignApi.commentIndex(campaignId, this.limit, this.offset)
      .then(function(comments) {
        if (comments.length === 0) {
          return
        }

        if (comments.length > 5) {
          var moreComments = comments.slice(comments.length - 5, comments.length)
          comments = comments.slice(0, comments.length - 5)
          var loadComment = new LoadComment().render(moreComments)
          loadComment.$el.on('click', function() { _this.load() })
          loadComment.$el.insertAfter(_this.$loading)
        }
        comments.forEach(function(data) {
          var commentItem = new CommentItem().render(data).el
          _this.$commentList.prepend(commentItem)
        })

        _this.offset = _.last(comments).CampaignComment.id
      })
      .always(function() {
        _this.$loading.hide()
      })
  }
})

var LoadComment = App.Views.Base.extend({
  className: 'p-cp-comment-more clearfix js-campaign-comment-load-more',
  tagName: 'a',
  template: require('../../../hbs/load_campaign_comment.hbs'),
  render: function(content) {
    // 退会ユーザーがいるとhbsがめんどくさいので除く
    content = content.filter(function(comment) {
      return comment.User.id !== null
    })
    var html = this.template(content)
    this.$el.html(html)
    return this
  }
})

var CommentItem = App.Views.Base.extend({
  className: 'p-cp-comment-list__item js-campaign-comment',
  tagName: 'li',
  template: require('../../../hbs/campaign_comment.hbs'),
  events: {
    'click .js-campaign-comment-remove': 'removeComment'
  },
  campaignCommentId: null,
  render: function(content) {
    this.campaignCommentId = content.CampaignComment.id
    content.CampaignComment.is_own = content.CampaignComment.user_id === App.me.User.id
    var html = this.template(content)
    this.$el.html(html)
    return this
  },
  removeComment: function() {
    if (! confirm('コメントを削除します。よろしいですか？')) {
      return
    }

    var _this = this
    this.$el.hide()
    campaignApi.commentRemove(this.campaignCommentId)
      .then(function() {
        _this.$el.remove()
      })
      .fail(function(error) {
        _this.$el.show()

        if (_.has(error, 'message')) {
          alert(error.message)
        } else {
          App.networkErrorAlert()
        }
      })
  }
})



// WEBPACK FOOTER //
// ./webroot/js/sp/views/campaign.js